import { Gameplay } from "appworks/model/gameplay/gameplay";
import { RequestBuilder } from "appworks/server/builders/request-builder";
import { SocketRequest } from "appworks/server/connectors/socket-connector";
import { gameiomModel } from "gameiom/model/gameiom-model";
import { PickRequestPayload } from "slotworks/model/gameplay/requests/pick-request-payload";

export class PickRequestBuilder implements RequestBuilder {
    public static force: string;
    protected action: string;

    constructor(action: string = "pick") {
        this.action = action;
    }

    public filter(request: any): boolean {
        return request instanceof PickRequestPayload;
    }

    public build(gameplay: Gameplay, request: PickRequestPayload): SocketRequest {
        const force: string | number[] = PickRequestBuilder.force;
        const action: string = request["action"] || this.getAction();

        const body = {
            publicState: {
                action,
                index: request.pick,
                gameId: gameiomModel.gameId,
                force
            }
        };

        if (body.publicState.force === null) {
            delete body.publicState.force;
        }

        PickRequestBuilder.force = null;

        return new SocketRequest(body, gameiomModel.url);
    }

    protected getAction(): string {
        return this.action;
    }
}
